// Page Builder pages carry a `kind`; each kind has its own canonical URL prefix.
export const PAGE_KINDS = ["event", "business", "org", "resource", "guide", "artist", "person", "example"];
export const KIND_PATH = { event: "festival", artist: "artist/page", org: "org", business: "business/page", person: "person", guide: "guide", example: "example", resource: "resource" };
export const KIND_LABEL = { event: "Event", artist: "Artist", org: "Org community page", business: "Business", person: "Person", guide: "Guide", example: "Example", resource: "Resource" };
export const KIND_HINT = {
  event: "Festival, show, market — dates, countdown, map, schedule",
  business: "A business splash: what you offer, your Gem, map pin, hours & links",
  org: "A community page for a non-profit: how to help, events, story, donate",
  resource: "A services directory for one need — who to call, where to go",
  guide: "A North Star-style guide for any issue: collapsible sections + share card",
  artist: "Band / artist page: music, shows, links",
  person: "A person's page — bio, story, links",
  example: "Demo / sandbox page",
};

export const kindPath = (f) => `/${KIND_PATH[f?.kind] || "festival"}/${f?.slug || ""}`;
export const pagePath = (f) => (f?.short_path ? `/${String(f.short_path).replace(/^\/+/, "")}` : kindPath(f));
